<nb-card class="helix-popup-body">
  <nb-card-header>
    <div class="header-container">{{ assetName }}</div>
  </nb-card-header>
  <nb-card-body>
    <div *ngIf="!assetContent?.length">Nothing to display</div>
    <div *ngFor="let content of assetContent" class="asset-property">
      <div class="asset-property-row">
        <div class="asset-property name">{{ content?.caption || "-" }}</div>
        <div class="asset-property value">{{ content?.content || "-" }}</div>
      </div>
    </div>
  </nb-card-body>
  <nb-card-footer>
    <button
      nbButton
      status="primary"
      ng-reflect-set-status="primary"
      class="btn-primary btn-outline btn-small"
      (click)="close()"
      i18n="@@asset-info-close-button"
    >
      Close
    </button>
  </nb-card-footer>
</nb-card>
